const TRANSFER_CREATE_PATH = '/warehouse-transfer/create';
const TRANSFER_CREATE_PENDING_LOGOUT_KEY = 'transfer_create_pending_logout';

const isBrowser = () => typeof window !== 'undefined';

export const isOnTransferCreatePage = (pathname?: string): boolean => {
  if (!isBrowser() && !pathname) {
    return false;
  }

  const currentPath = pathname ?? window.location.pathname;
  return currentPath.startsWith(TRANSFER_CREATE_PATH);
};

export const markTransferCreatePendingLogout = (): void => {
  if (!isBrowser()) return;
  sessionStorage.setItem(TRANSFER_CREATE_PENDING_LOGOUT_KEY, '1');
};

export const hasTransferCreatePendingLogout = (): boolean => {
  if (!isBrowser()) return false;
  return sessionStorage.getItem(TRANSFER_CREATE_PENDING_LOGOUT_KEY) === '1';
};

export const clearTransferCreatePendingLogout = (): void => {
  if (!isBrowser()) return;
  sessionStorage.removeItem(TRANSFER_CREATE_PENDING_LOGOUT_KEY);
};
